module.exports = {
  finance_inputBusinessNumber: 'กรุณากรอกรหัสธุรกิจ',
  finance_query: 'ค้นหา',
  finance_view: 'ดู',
  finance_returnQuery: 'กลับไปที่การค้นหา',
  finance_batchAudit: 'ตรวจสอบเป็นกลุ่ม',
  finance_lockTheBill: 'ล็อคออเดอร์',
  finance_accrue: 'กันเงิน',
  finance_businessCommission: 'คอมมิชชั่นธุรกิจ',
  finance_cancelAccrue: 'ยกเลิกการกันเงิน',
  finance_print: 'พิมพ์',
  finance_audit: 'ตรวจสอบ',
  finance_cancelTheAudit: 'ยกเลิกการตรวจสอบ',
  finance_chargesAudit: 'ตรวจสอบค่าใช้จ่าย',
  finance_cancelTheChargesAudit: 'ยกเลิกการตรวจสอบค่าใช้จ่าย',
  finance_printTheProfit: 'พิมพ์กำไร',
  finance_editFinancialDate: 'แก้ไขวันที่ทางการเงิน',
  finance_businessAdjustment: 'ปรับปรุงธุรกิจ',
  finance_editChargeFinancialDate: 'แก้ไขวันที่ทางการเงินของค่าใช้จ่าย',
  finance_basic: 'พื้นฐาน',
  finance_booking: 'จองพื้นที่',
  finance_charges: 'ค่าใช้จ่าย',
  finance_domesticBill: 'บิลภายในประเทศ',
  finance_internationalBill: 'บิลต่างประเทศ',
  finance_collectAndPrepaid: 'รับเงินแทน/จ่ายแทน',
  finance_fileHistory: 'ประวัติไฟล์',
  finance_exportExcelAll: 'ส่งออกทั้งหมด',
  finance_updateBusinessDate: 'แก้ไขวันที่ธุรกิจ',
  finance_log: 'บันทึก',
  finance_allowChange: 'อนุญาตให้แก้ไขออเดอร์',
  finance_checkChange: 'ตรวจสอบการแก้ไขออเดอร์',
  finance_batchCheckChange: 'ตรวจสอบการแก้ไขออเดอร์เป็นกลุ่ม',
  finance_revokeChangeCommit: 'ถอนการส่งแก้ไขออเดอร์',
  charge_receivables: 'ลูกหนี้',
  charge_equivalent: 'แปลงค่า',
  charge_inviteToConfirmTheCharges: 'เชิญยืนยันค่าใช้จ่าย',
  charge_newAdjustment: 'เพิ่มการปรับปรุง',
  charge_editAdjustment: 'แก้ไขการปรับปรุง',
  charge_deleteAdjustment: 'ลบการปรับปรุง',
  charge_writeOffList: 'รายละเอียดการตัดจ่าย',
  charge_chargesReject: 'ปฏิเสธค่าใช้จ่าย',
  charge_chargeItem: 'ชื่อค่าใช้จ่าย',
  charge_settleAccountsTo: 'ผู้ชำระเงิน',
  charge_invoiceHeader: 'ชื่อในใบแจ้งหนี้',
  charge_somesticOrInternational: 'ในประเทศ/ต่างประเทศ',
  charge_drawABillOrNot: 'ต้องการออกใบแจ้งหนี้หรือไม่',
  charge_currency: 'สกุลเงิน',
  charge_localCurrency: 'สกุลเงินหลัก',
  charge_exchangeRate: 'อัตราแลกเปลี่ยน',
  charge_unit: 'หน่วย',
  charge_amount: 'จำนวน',
  charge_unitPrice: 'ราคาต่อหน่วย',
  charge_taxIncludedPrice: 'ราคารวมภาษี',
  charge_taxExcludedPrice: 'ราคาไม่รวมภาษี',
  charge_taxRate: 'อัตราภาษี',
  charge_whtTaxRate: 'อัตราภาษีหัก ณ ที่จ่าย (WHT)',
  charge_payables: 'ต้องชำระ',
  charge_controlled: 'อยู่ภายใต้การควบคุม',
  charge_cancelControlled: 'ยกเลิกการควบคุม',
  charge_taxAmount: 'จำนวนภาษี',
  charge_whtTaxAmount: 'จำนวนภาษีหัก ณ ที่จ่าย (WHT)',
  charge_whtTaxLocalAmount: 'จำนวนภาษีหัก ณ ที่จ่าย (สกุลเงินหลัก)',
  charge_notWhtAmount: 'จำนวนเงินหลังหัก WHT',
  charge_remarks: 'หมายเหตุ',
  charge_contactPerson: 'ผู้ติดต่อ',
  charge_relatedBLNo: 'หมายเลขใบตราส่งที่เกี่ยวข้อง',
  charge_relatedContainerNo: 'หมายเลขตู้ที่เกี่ยวข้อง',
  charge_freightCollectOrPrepaid: 'ชำระล่วงหน้าหรือปลายทาง',
  charge_status: 'สถานะ',
  charge_conversionRMB: 'แปลงเป็นเงินหยวน',
  charge_confirmOrNot: 'ยืนยันหรือไม่',
  charge_billNo: 'หมายเลขบิล',
  charge_agent_billNo: 'หมายเลขบิลแบ่งส่วนตัวแทน',
  charge_containerNo: 'หมายเลขตู้',
  charge_invoiceNo: 'หมายเลขใบแจ้งหนี้',
  charge_invoiceDate: 'วันที่ออกใบแจ้งหนี้',
  charge_agentBillNo: 'หมายเลขบิลของอีกฝ่าย',
  charge_theAmountOfWriteOffs: 'จำนวนเงินที่ตรวจสอบแล้ว',
  charge_writeOffDate: 'วันที่ตัดบัญชี',
  charge_financialDate: 'วันที่ทางการเงิน',
  charge_businessNumber: 'รหัสธุรกิจ',
  charge_creator: 'ผู้สร้าง',
  charge_createTime: 'เวลาที่สร้าง',
  charge_editor: 'ผู้แก้ไข',
  charge_editTime: 'เวลาที่แก้ไข',
  charge_paymentApplicationNo: 'หมายเลขคำขอชำระเงิน',
  charge_profit: 'กำไร',
  charge_profitAll: 'กำไรรวม',
  charge_estimateRemarks: 'หมายเหตุการประมาณการ',
  charge_showRedCharges: 'แสดงค่าใช้จ่ายที่ถูกยกเลิก',
  charge_auditor: 'ผู้ตรวจสอบ',
  charge_estimate: 'ประมาณการ',
  charge_add: 'เพิ่มใหม่',
  charge_copy: 'คัดลอกค่าใช้จ่าย',
  charge_delete: 'ลบ',
  charge_edit: 'แก้ไข',
  charge_chargesAudit: 'ตรวจสอบค่าใช้จ่าย',
  charge_cancelTheAudit: 'ยกเลิกการตรวจสอบ',
  charge_showCommonCharge: 'แสดงค่าใช้จ่ายทั่วไป',
  charge_showSpecialCharge: 'แสดงค่าใช้จ่ายพิเศษ',
  charge_sp1: 'หมายเลขอัตราค่าขนส่ง',
  charge_sp2: 'คลิกเพื่อคัดลอกหมายเลขใบเสนอราคา',
  charge_sp3: 'เพิ่มตามบริการ',
  charge_sp4: 'อัปเดตอัตราแลกเปลี่ยน',
  charge_sp5: 'คัดลอกค่าใช้จ่ายจากใบเสร็จ',
  charge_sp6: 'คัดลอกเงินที่ต้องจ่าย',
  charge_sp7: 'แผนค่าใช้จ่าย',
  charge_sp8: 'ตารางค่าโดยสาร',
  charge_sp9: 'ยกเลิกการส่ง',
  charge_sp10: 'ส่งค่าใช้จ่าย',
  charge_sp11: 'การแบ่งปันค่าใช้จ่าย',
  charge_sp12: 'แสดงค่าใช้จ่ายแยกตั๋ว',
  charge_sp13: 'รายการบริการ',
  charge_copyCost: 'คัดลอกเงินที่ต้องรับ',
  charge_copyCharge: 'คัดลอกค่าใช้จ่าย',
  charge_payReceiveDate: 'วันที่รับ/จ่าย',
  charge_actualAmountNo: 'หมายเลขการตัดบัญชี',
  charge_newChange: 'เพิ่มค่าใช้จ่ายการแก้ไขใบสั่ง',
  charge_editChange: 'แก้ไขค่าใช้จ่ายการแก้ไขใบสั่ง',
  charge_deleteChange: 'ลบค่าใช้จ่ายการแก้ไขใบสั่ง',
  charge_shared: 'แบ่งปัน',
  charge_showSharedCharges: 'แสดงค่าใช้จ่ายที่แบ่งปัน',
  charge_newSpecial: 'เพิ่มค่าใช้จ่ายพิเศษ',
  charge_editSpecial: 'แก้ไขค่าใช้จ่ายพิเศษ',
  charge_unitPriceIncludeTax: 'ราคาต่อหน่วยรวมภาษีหรือไม่',
  charge_locked_status: 'ถูก锁定หรือไม่',
  domestic_showAllBilling: 'แสดงบิลทั้งหมด',
  domestic_commissionedChargesOnly: 'แสดงเฉพาะค่าใช้จ่ายของมอบหมายนี้',
  domestic_newReceivables: 'สร้างเงินที่ต้องรับใหม่',
  domestic_newPayables: 'สร้างเงินที่ต้องจ่ายใหม่',
  domestic_edit: 'แก้ไข',
  domestic_delete: 'ลบ',
  domestic_view: 'ดู',
  domestic_confirm: 'ยืนยัน',
  domestic_cancelConfirm: 'ยกเลิกการยืนยัน',
  domestic_billNo: 'หมายเลขบิล',
  domestic_settleAccountTto: 'วัตถุการชำระเงิน',
  domestic_settlementAgent: 'ตัวแทนการชำระเงิน',
  domestic_invoiceHeader: 'ชื่อในใบแจ้งหนี้',
  domestic_currency: 'สกุลเงิน',
  domestic_chargeAmount: 'จำนวนเงิน',
  domestic_totalCurrency: 'รวมตามสกุลเงิน',
  domestic_revenueAndExpenditureType: 'ประเภทรายรับรายจ่าย',
  domestic_confirmationStatus: 'สถานะการยืนยัน',
  domestic_invoicingStatus: 'สถานะการออกใบแจ้งหนี้',
  domestic_writeOffStatus: 'สถานะการตัดบัญชี',
  domestic_revenueOrExpenditure: 'รายรับรายจ่าย',
  domestic_chargeItem: 'ชื่อค่าใช้จ่าย',
  domestic_unit: 'หน่วย',
  domestic_amount: 'จำนวน',
  domestic_unitPrice: 'ราคาต่อหน่วย',
  domestic_taxIncludedPrice: 'ราคารวมภาษี',
  domestic_taxExcludedPrice: 'ราคาไม่รวมภาษี',
  domestic_taxRate: 'อัตราภาษี',
  domestic_taxAmount: 'จำนวนภาษี',
  domestic_remarks: 'หมายเหตุ',
  domestic_billingGroupNo: 'เลขที่ใบแจ้งหนี้',
  domestic_billingBranchId: 'สาขาที่ออกใบแจ้งหนี้',
  international_showAllBilling: 'แสดงใบแจ้งหนี้ทั้งหมด',
  international_commissionedChargesOnly: 'แสดงเฉพาะค่าบริการที่มอบหมาย',
  international_add: 'เพิ่มใหม่',
  international_edit: 'แก้ไข',
  international_delete: 'ลบ',
  international_audit: 'ตรวจสอบ',
  international_invalid: 'ยกเลิก',
  international_agentProfitShareBillNo: 'ตัวแทนแบ่งการเรียกเก็บเงิน',
  international_printAllAgentProfitShareBillNo: 'พิมพ์ใบแจ้งหนี้ตัวแทนทั้งหมด',
  international_editAgentBillNo: 'แก้ไขเลขที่ใบแจ้งหนี้ของอีกฝ่าย',
  international_billNo: 'เลขที่ใบแจ้งหนี้',
  international_agentBillNo: 'เลขที่ใบแจ้งหนี้ของอีกฝ่าย',
  international_revenueAndExpenditureType: 'ประเภทรายรับ-รายจ่าย',
  international_settleAccountTo: 'วัตถุการชำระเงิน',
  international_settlementAgent: 'ตัวแทนชำระเงิน',
  international_currency: 'สกุลเงิน',
  international_chargeAmount: 'จำนวนเงิน',
  international_status: 'สถานะ',
  international_billType: 'ประเภทใบแจ้งหนี้',
  international_invoicingStatus: 'สถานะการออกใบแจ้งหนี้',
  international_writeOffStatus: 'สถานะการตรวจสอบ',
  international_billDtae: 'วันที่ออกใบแจ้งหนี้',
  international_creator: 'ผู้สร้าง',
  international_businessNumber: 'เลขที่ธุรกรรม',
  international_billingGroupNo: 'เลขที่ใบแจ้งหนี้',
  international_revenueOrExpenditure: 'รายรับ-รายจ่าย',
  international_chargeItem: 'ชื่อค่าใช้จ่าย',
  international_taxIncludedPrice: 'ราคารวมภาษี',
  international_taxExcludedPrice: 'ราคาไม่รวมภาษี',
  international_taxRate: 'อัตราภาษี',
  international_taxAmount: 'จำนวนภาษี',
  international_unit: 'หน่วย',
  international_amount: 'จำนวน',
  international_unitPrice: 'ราคาต่อหน่วย',
  international_remarks: 'หมายเหตุ',
  adChargeInfo_prepaid: 'จ่ายแทน',
  adChargeInfo_print: 'พิมพ์',
  adChargeInfo_newAdjustment: 'เพิ่มการปรับปรุง',
  adChargeInfo_editAdjustment: 'แก้ไขการปรับปรุง',
  adChargeInfo_deleteAdjustment: 'ลบการปรับปรุง',
  adChargeInfo_addBoth: 'เพิ่มพร้อมกัน',
  adChargeInfo_add: 'เพิ่มใหม่',
  adChargeInfo_delete: 'ลบ',
  adChargeInfo_chargeItem: 'ชื่อค่าใช้จ่าย',
  adChargeInfo_settleAccountsTo: 'วัตถุการชำระเงิน',
  adChargeInfo_domesticOrInternational: 'ในประเทศ/ต่างประเทศ',
  adChargeInfo_currency: 'สกุลเงิน',
  adChargeInfo_unit: 'หน่วย',
  adChargeInfo_quantity: 'จำนวน',
  adChargeInfo_unitPrice: 'ราคาต่อหน่วย',
  adChargeInfo_exchangeRate: 'อัตราแลกเปลี่ยน',
  adChargeInfo_amount: 'จำนวนเงิน',
  adChargeInfo_remarks: 'หมายเหตุ',
  adChargeInfo_billNo: 'เลขที่บิล',
  adChargeInfo_taxNo: 'เลขที่ภาษี',
  arChargeInfo_theAmountOfWriteOffs: 'จำนวนเงินที่ตรวจสอบแล้ว',
  apChargeInfo_theAmountOfWriteOffs: 'จำนวนเงินที่ตรวจสอบแล้ว',
  adChargeInfo_collect: 'รับแทน',
  adChargeInfo_submitCharge: 'ส่งค่าใช้จ่าย',
  adChargeInfo_cancelSubmit: 'ยกเลิกการส่ง',
  adChargeInfo_status: 'สถานะ',
  adChargeInfo_paymentApplicationNo: 'เลขที่คำขอชำระเงิน',
  international_forceDelete: 'ลบแบบบังคับ',
  return: 'กลับ',
  Confirm: 'ตกลง',
  Cancel: 'ยกเลิก',
  accrualDate: 'วันที่จัดสรร',
  adjustmentItem: 'รายการปรับปรุง',
  adjustmentValue: 'ค่าปรับปรุง',
  charge_ProvisionedDate: 'วันที่จัดสรร',
  charge_specialUpdate: 'การปรับปรุงค่าใช้จ่ายพิเศษ',
  charge_settleDepartmentPrefix: 'แผนกชำระเงิน',
  charge_paymentApplicationDateCreated: 'วันที่สร้างใบเรียกเก็บเงิน',
  charge_SapStatus: 'สถานะ SAP',
  finance_ChargeCommit: 'ส่งการแก้ไข',
  separateAllocation: 'สถานการณ์การแบ่งบิล',
  allocationType: 'ประเภทการแบ่งปัน',
  costSharingValue: 'ค่าการแบ่งปันค่าใช้จ่าย',
  modifyField: 'แก้ไขฟิลด์',
  operationContent: 'เนื้อหาการดำเนินการ',
  statusAfterOperation: 'สถานะหลังดำเนินการ',
  routeLeader: 'ผู้รับผิดชอบเส้นทาง',
  selectAdjustmentItem: 'กรุณาเลือกรายการปรับปรุง',
  businessInfoAdjustedSuccess: 'ปรับปรุงข้อมูลธุรกิจสำเร็จ',
  apportionedTax: 'แบ่งปันภาษี',
  charge_asyncCharges: 'ซิงค์ค่าใช้จ่าย',
  charge_asyncChargeRecords: 'บันทึกการซิงค์ค่าใช้จ่าย',
  lockBusinessSuccess: 'ล็อคบิลสำเร็จ',
  AccountVerifyBusinessSuccess: 'ตรวจสอบสำเร็จ',
  AccrualSucceeded: 'จัดสรรสำเร็จ',
  charge_asyncChargesToImportJob: 'ซิงค์ไปยังธุรกิจนำเข้า',
  charge_syncChargesConfirmStatus: 'สถานะซิงค์ค่าใช้จ่าย',
  charge_cancelSyncChargesConfirmStatus: 'ยกเลิกสถานะซิงค์ค่าใช้จ่าย',
  charge_syncChargesToSI: 'ซิงค์ค่าธรรมเนียมการนำเข้า',
  charge_cancelSyncChargesToSI: 'ยกเลิกการซิงค์ค่าธรรมเนียมการนำเข้า',
  charge_paymentAmount: 'จำนวนเงินรับ/จ่าย',
  expenseSharingReceipt: 'ใบแจกแจงค่าใช้จ่าย',
  correspondingAllocationBusiness: 'งานที่เกี่ยวข้องกับการแบ่งปัน',
  allocateRelatedBusinesses: 'ธุรกิจที่เกี่ยวข้องกับการแบ่งปัน',
  BusinessSyncModifyBusinessDate: 'ธุรกิจส่งออกจะปรับปรุงวันที่ธุรกิจให้ตรงกัน',
  ImportBusinessSyncModifyBusinessDate: 'ธุรกิจนำเข้าจะปรับปรุงวันที่ธุรกิจให้ตรงกัน',
  ExportBusinessItemCannotEmpty: 'ธุรกิจส่งออก ห้ามเว้นว่างรายการนี้',
  ImportBusinessItemCannotEmpty: 'ธุรกิจนำเข้า ห้ามเว้นว่างรายการนี้',
  LandTransportationBusinessItemCannotEmpty: 'ธุรกิจขนส่งทางบก ห้ามเว้นว่างรายการนี้',
  synchronizationFeesToBeProcessed: 'ค่าธรรมเนียมที่ต้องซิงค์รอการดำเนินการ',
  markAsRead: 'ทำเครื่องหมายว่าอ่านแล้ว',
  fail: 'ไม่ผ่าน',
  applyRecallCharge: 'ขอถอนค่าธรรมเนียม',
  recallState: 'สถานะการถอน',
  recallCause: 'เหตุผลการถอน',
  youCanOnlyOperateOnConfirmedCharges: 'ดำเนินการได้เฉพาะค่าธรรมเนียมที่ยืนยันแล้ว',
  thereAreCostsThatHaveBeenWithdrawn: 'มีค่าธรรมเนียมที่ถูกถอนไปแล้ว กรุณาอย่าส่งซ้ำ',
  theFeeHasEnteredTheSettlementProcess: 'ค่าธรรมเนียมเข้าสู่ขั้นตอนการชำระเงินแล้ว ไม่สามารถถอนได้ ต้องยกเลิกการเชื่อมโยงจากเอกสารต่างๆ เช่น การยืนยันการตรวจสอบ บิล ใบแจ้งหนี้ คำขอชำระเงิน บันทึกการตัดจ่าย เป็นต้น',
  PleaseSeparateTheFeesForConfirmationAndWithdrawal: 'กรุณาดำเนินการแยกกันระหว่างค่าธรรมเนียมที่รอยืนยันครั้งแรกและค่าธรรมเนียมที่ขอถอน',
  receivablePayable: 'รับได้/ต้องจ่าย',
  currency: 'สกุลเงิน',
  sender: 'ผู้ส่ง',
  receiver: 'ผู้รับ',
  syncProgress: 'ความคืบหน้าของการซิงค์',
  processingStatus: 'สถานะการประมวลผล',
  sendingTime: 'เวลาที่ส่ง',
  auditOperationTime: 'เวลาดำเนินการตรวจสอบ',
  pending: 'รอดำเนินการ',
  alreadyRead: 'อ่านแล้ว',
  notRead: 'ยังไม่อ่าน',
  businessHasBeenSubmitted: 'ธุรกิจถูกส่งแล้ว ไม่สามารถอนุมัติและเพิ่มค่าธรรมเนียมได้ หากจำเป็น กรุณาติดต่อผู้จัดการธุรกิจเพื่อยกเลิกการส่ง',
  selectBeConfirmedChargeByUs: 'กรุณาเลือกค่าธรรมเนียมที่รอการยืนยันจากฝ่ายเรา',
  selectRejectedChargeByOppositeParty: 'กรุณาเลือกค่าธรรมเนียมที่อีกฝ่ายปฏิเสธแล้ว',
  pleaseSaveTheCurrentPageFirst: 'กรุณาบันทึกหน้าปัจจุบันก่อน',
  commissionAmount: 'จำนวนคอมมิชชั่น',
  charge_writeOffDate_ar: 'วันที่ตัดจ่าย',
  charge_writeOffDate_ap: 'วันที่ตัดจ่าย',
  GenerateVoucher: 'สร้างเอกสารหลักฐานแล้วหรือไม่',
  CurrencyAccountsReceivable: 'รับได้แยกตามสกุลเงิน:',
  CurrencyAccountsPayable: 'ต้องจ่ายแยกตามสกุลเงิน:',
  today: 'วันเดียวกัน',
  thisMonthEnd: 'สิ้นเดือนนี้',
  previousMonthEnd: 'สิ้นเดือนที่แล้ว',
  IssueMonthOfYear: 'ปี {0} งวดที่ {1}',
  QMonthYear: 'ปี {0} ไตรมาสที่ {1}',
  XYear: 'ปี {0}',
  SongtiSerif: 'ฟอนต์ซ่ง, serif',
  TrialBalance: 'ตารางยอดคงเหลือบัญชี',
  BalanceSheetWithContacts: 'รายงานยอดคงเหลือระหว่างกัน',
  StatementOfAccountWithContacts: 'บัญชีตรวจสอบระหว่างกัน',
  SubsidiaryLedger: 'บัญชีแยกประเภท',
  GeneralLedger: 'บัญชีแยกประเภททั่วไป',
  Receive: 'รับ',
  Pay: 'จ่าย',
  Transfer: 'โอน',
  ForeignCurrencyRevaluation: 'ปรับอัตราแลกเปลี่ยนปลายงวด',
  RetainedEarnings: 'ปิดบัญชีกำไรขาดทุนประจำงวด',
  Billion: 'ร้อยล้าน',
  Thousand: 'พัน',
  Hundred: 'ร้อย',
  Ten: 'สิบ',
  TenThousand: 'หมื่น',
  Yuan: 'หยวน',
  Dime: 'เจี่ยว',
  Cent: 'เฟิน',
  FailedObtainCurrentFiscalPeriod: 'ไม่สามารถดึงข้อมูลงวดบัญชีปัจจุบันได้!',
  Total: 'รวม',
  Quantity: 'จำนวน:',
  UnitPrice: 'ราคาต่อหน่วย:',
  ForeignCurrency: 'สกุลเงินเดิม:',
  UnbalancedDebitAndCreditEntry: 'บันทึกบัญชีไม่สมดุล!',
  ThisVoucherPleaseEditInModule: 'เอกสารนี้เป็นเอกสารทางธุรกิจ\nกรุณาแก้ไขในโมดูล "สร้างเอกสาร"',
  ForeignCurrencyCannotBeEmpty: 'สกุลเงินเดิมไม่สามารถเว้นว่างได้',
  ClientItemCannotBeEmpty: 'ข้อมูลลูกค้าไม่สามารถเว้นว่างได้',
  SupplierItemCannotBeEmpty: 'ข้อมูลผู้ขายไม่สามารถเว้นว่างได้',
  StaffItemCannotBeEmpty: 'ข้อมูลพนักงานไม่สามารถเว้นว่างได้',
  ProjectItemCannotBeEmpty: 'ข้อมูลโครงการไม่สามารถเว้นว่างได้',
  DepartmentItemCannotBeEmpty: 'ข้อมูลแผนกไม่สามารถเว้นว่างได้',
  Client: 'ลูกค้า',
  Supplier: 'ผู้ขาย',
  Department: 'แผนก',
  Staff: 'พนักงาน',
  Project: 'โครงการ',
  Currency: 'สกุลเงิน:',
  Amount: 'จำนวนเงิน:',
  ExchangeRate: 'อัตราแลกเปลี่ยน:',
  All: 'ทั้งหมด',
  Yes: 'ใช่',
  No: 'ไม่',
  Year: 'ปี',
  Period: 'งวด',
  PleaseSelectVoucherRange: 'กรุณาเลือกช่วงเอกสาร',
  Assets: 'สินทรัพย์',
  Liabilities: 'หนี้สิน',
  Equity: 'ส่วนของผู้ถือหุ้น',
  Cost: 'ต้นทุน',
  ProfitAndLoss: 'กำไรขาดทุน',
  ClientSupplier: 'ลูกค้า/ผู้ขาย',
  BalanceInRMB: 'ยอดคงเหลือ (หยวน)',
  UnmatchedClientOrSupplier: 'ลูกค้าหรือซัพพลายเออร์ที่ยังไม่จับคู่',
  AddAssetAccount: 'เพิ่มบัญชีประเภทสินทรัพย์',
  Add: 'เพิ่มใหม่',
  Edit: 'แก้ไข',
  Delete: 'ลบ',
  AddCashFlowItem: 'เพิ่มรายการกระแสเงินสด',
  ImportSucceeded: 'นำเข้าเสร็จสิ้น',
  DesignSubaccounts: 'ออกแบบบัญชีย่อย',
  NeedToExport: 'ต้องการส่งออก',
  NoExportNeeded: 'ไม่ต้องการส่งออก',
  SeparatorSettings: 'ตั้งค่าตัวคั่น',
  ExportSeparator: 'ตัวคั่นการส่งออก',
  Separator: 'ตัวคั่น:',
  PleaseFinancialYearForReport: 'กรุณากรอกปีงบประมาณที่ต้องการเริ่มต้นรายงาน',
  RepeatingDataLossPleaseCaution: 'การเริ่มต้นซ้ำจะทำให้ข้อมูลที่บันทึกไว้หายไป โปรดใช้อย่างระมัดระวัง',
  InitializationPleaseCheckAccountSettings: 'เริ่มต้นเสร็จสิ้น โปรดตรวจสอบการตั้งค่าบัญชี',
  InitializationPleaseCheckTheReport: 'เริ่มต้นเสร็จสิ้น โปรดตรวจสอบรายงาน',
  DetailedEntryRulesConfiguration: 'การกำหนดกฎสรุปบัญชี',
  FeeWillBeDeleted: 'หมายเหตุ: จะลบค่าใช้จ่าย {0} รายการ',
  AccountNotFound: 'ไม่มีชุดบัญชีนี้',
  Quarter: 'ไตรมาส',
  AccountingVoucher: 'เอกสารทางบัญชี',
  StatusUnknown: 'สถานะไม่ทราบ',
  N0Year0Period: 'ปี {0} งวดที่ {1}',
  SyncCloudSucceededXFailedX: 'ซิงค์ Cloud Star สำเร็จ {0} รายการ ล้มเหลว {1} รายการ',
  SyncExceptionReason: 'สาเหตุการซิงค์ผิดปกติ',
  SyncCloudStarrySky: 'ซิงค์ Cloud Star',
  SyncFeeCannotSyncAgain: 'ค่าใช้จ่ายที่ซิงค์แล้วไม่สามารถซิงค์ซ้ำได้!',
  DisplayTransactions: 'แสดงธุรกรรมระหว่างกัน',
  EnterBusinessNumberBeforeQuery: 'กรุณากรอกรหัสธุรกรรมก่อนค้นหา',
  SelectNewEncodingType: 'เลือกประเภทรหัสที่ต้องการเพิ่ม',
  SelectMatchingPartnerFieldType: 'เลือกประเภทฟิลด์คู่ค้าที่ต้องการจับคู่',
  NewEncodingType: 'ประเภทรหัสที่เพิ่มใหม่:',
  CustomerCode: 'รหัสลูกค้า',
  SupplierCode: 'รหัสซัพพลายเออร์',
  AtLeastOneCustomerAndSupplierCode: 'ต้องเลือกรหัสลูกค้าหรือรหัสซัพพลายเออร์อย่างน้อยหนึ่งรายการ',
  MatchPartnerFieldTypes: 'ประเภทฟิลด์คู่ค้าที่จับคู่:',
  PartnersCode: 'คู่ค้า_รหัส',
  PartnersNumber: 'คู่ค้า_เลขที่',
  PartnersChineseName: 'คู่ค้า_ชื่อภาษาจีน',
  ImportCustomerAndProviderCode: 'ยืนยันที่จะนำเข้า [{0}] เป็นรหัสลูกค้าและรหัสซัพพลายเออร์ของคู่ค้าในชุดบัญชีนี้?',
  ImportCustomerCode: 'ยืนยันที่จะนำเข้า [{0}] เป็นรหัสลูกค้าของคู่ค้าในชุดบัญชีนี้?',
  ImportProviderCode: 'ยืนยันที่จะนำเข้า [{0}] เป็นรหัสซัพพลายเออร์ของคู่ค้าในชุดบัญชีนี้?',
  ImportCodePenddingTip: 'กำลังนำเข้ารหัสลูกค้า/ซัพพลายเออร์...<br>การออกจากหน้านี้จะไม่กระทบกระบวนการนำเข้า ระบบจะแจ้งให้ทราบเมื่อนำเข้าเสร็จสิ้น',
  ModifyExpirationDate: 'แก้ไขวันครบกำหนด',
  ModifyChargeExpirationDate: 'แก้ไขวันครบกำหนดค่าใช้จ่าย',
  RemoveCountFee: 'กรุณาลบค่าใช้จ่ายที่คำนวณแล้ว',
  ChargeHqCurrency: 'สกุลเงินท้องถิ่นของสำนักงานใหญ่',
  ChargeHqRate: 'อัตราแลกเปลี่ยนสกุลเงินท้องถิ่นสำนักงานใหญ่',
  CostType: 'ประเภทต้นทุน',
  HideForeignCurrencyProfitLoss: 'ไม่แสดงการโอนยอดกำไรขาดทุนสกุลเงินต่างประเทศ',
  GpExplain: 'คำอธิบาย GP',
  Peer: 'หน่วยมอบหมายเป็นธนาคารเดียวกันหรือไม่',
  ProfitRate: 'อัตรากำไร',
  ArRowsAndApRows: 'จำนวนรายการลูกหนี้/เจ้าหนี้',
  ArIncludeAp: 'ลูกหนี้รวมเจ้าหนี้',
  Allocation: 'Allocation',
  LclTicketsCanNotAudit: 'ไม่สามารถตรวจสอบบิลย่อยแบบรวมได้ กรุณาตรวจสอบบิลหลัก',
  SelectedDataJobSubmitNotAllowAudit: 'ข้อมูลที่เลือกมีผู้ส่งงานและผู้ตรวจสอบปัจจุบันเป็นคนเดียวกัน ไม่允许ตรวจสอบ กรุณาตรวจสอบ!',
  SelectedDataJobSubmitNotAllowCancelAudit: 'ข้อมูลที่เลือกมีผู้ส่งและผู้ตรวจสอบปัจจุบันเป็นคนเดียวกัน ไม่允许ยกเลิกการตรวจสอบ กรุณาตรวจสอบ!',
  SelectedDataChargeByNotAllowCancelAudit: 'ข้อมูลที่เลือกมีผู้ส่งแก้ไขและผู้ตรวจสอบปัจจุบันเป็นคนเดียวกัน ไม่允许ตรวจสอบ กรุณาตรวจสอบ!',
  JobSubmitNotAllowAudit: 'ผู้ส่งงานและผู้ตรวจสอบปัจจุบันเป็นคนเดียวกัน ไม่允许ตรวจสอบ!',
  JobSubmitNotAllowCancelAudit: 'ผู้ส่งงานและผู้ตรวจสอบปัจจุบันเป็นคนเดียวกัน ไม่允许ยกเลิกการตรวจสอบ!',
  JobSubmitNotAllowCancelChangeOrder: 'ผู้ส่งงานและผู้ตรวจสอบปัจจุบันเป็นคนเดียวกัน ไม่允许แก้ไข!',
  ChargeSubmitNotAllowAudit: 'ผู้ส่งค่าใช้จ่ายและผู้ตรวจสอบปัจจุบันเป็นคนเดียวกัน ไม่允许ตรวจสอบ!',
  ChargeSubmitNotAllowCancelAudit: 'ผู้ส่งค่าใช้จ่ายและผู้ตรวจสอบปัจจุบันเป็นคนเดียวกัน ไม่允许ยกเลิกการตรวจสอบค่าใช้จ่าย!',
  ChargeSubmitNotAllowCancelChangeOrder: 'ผู้ส่งค่าใช้จ่ายและผู้ตรวจสอบปัจจุบันเป็นคนเดียวกัน ไม่允许ตรวจสอบการแก้ไข!',
  AdditionalCostRemarks: 'หมายเหตุค่าใช้จ่ายเพิ่มเติม',
  AdditionalCostRemarksContent: 'เนื้อหาหมายเหตุค่าใช้จ่ายเพิ่มเติม',
  JobSubmitNotAllowCancelAdjustCosts: 'ผู้ส่งงานและผู้ตรวจสอบปัจจุบันเป็นคนเดียวกัน ไม่允许ปรับค่าใช้จ่าย!'
}
